import { ICreateCredentials, IUpdateCredentials, IGetPaginatedCredentials } from 'types';
import {
	serviceGetCredentialsInfo,
	serviceCreateCredentials,
	serviceUpdateCredentials,
	serviceGetPaginatedCredentials,
	serviceDeleteCredentials,
} from 'services/api/credentials';
import { createAppErrorMessage } from 'utils/helpers';

const getCredentialsInfo = async (credentialID: string) => {
	try {
		const response = await serviceGetCredentialsInfo(credentialID);
		return response;
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'dataNotPulled');
		throw new Error(errorMessage);
	}
};

const createCredentials = async (data: ICreateCredentials) => {
	try {
		await serviceCreateCredentials(data);
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'errorCreatingCredentials');
		throw new Error(errorMessage);
	}
};

const updateCredentials = async (data: IUpdateCredentials) => {
	try {
		await serviceUpdateCredentials(data);
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'errorUpdatingCredentials');
		throw new Error(errorMessage);
	}
};

const getPaginatedCredentials = async (args: IGetPaginatedCredentials) => {
	try {
		const response = await serviceGetPaginatedCredentials(args);
		return response;
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'dataNotPulled');
		throw new Error(errorMessage);
	}
};

const deleteCredentials = async (credentialID: string) => {
	try {
		await serviceDeleteCredentials(credentialID);
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'errorDeletingCredentials');
		throw new Error(errorMessage);
	}
};

export { getCredentialsInfo, createCredentials, updateCredentials, getPaginatedCredentials, deleteCredentials };
